export default "__VITE_ASSET__BtEfNN8E__"